import styles from './IFrame.module.scss';

type IFrameProps = {
  src: string;
  title?: string;
  width?: string;
  widthUnit?: string;
  height?: string;
  kontentItemId?: string;
};

export function IFrame(props: IFrameProps) {
  const { src, title, width, height, widthUnit, kontentItemId } = props;

  const widthWithUnit = width && widthUnit ? width + widthUnit : undefined;

  return (
    <iframe
      src={src}
      title={title || 'External content'}
      width={widthWithUnit || '100%'}
      height={height || 'auto'}
      loading="lazy"
      className={styles.iframe}
      data-kontent-item-id={kontentItemId}
    />
  );
}

export default IFrame;
